import classNames from "classnames";
// React
import React from "react";
import { Link } from "react-router";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./Card.less";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class Card extends React.Component {
    render() {
        const { url, label, description } = this.props;
        return (React.createElement(Link, { className: classNames("panel panel-default", styles.card), to: url },
            React.createElement("span", { className: "panel-body" },
                React.createElement("span", { className: styles.link }, label),
                React.createElement("span", { className: styles.description }, description))));
    }
}
